class ImageSlider extends HTMLElement {
    data = [];
    images = [];
    touchstartX = 0;
    touchendX = 0;
    touchScaling = false;

    constructor() {
        super();

        this.incrementPos = this.incrementPos.bind(this);
        this.decrementPos = this.decrementPos.bind(this);
        this.onSwipe = this.onSwipe.bind(this);

        this.attachShadow({ mode: "open" });
        const style = document.createElement("style");
        style.innerHTML = `
            :host {
                --controls-scale: 1;
                --modal-z-index: 100;
            }
        
            * {
                box-sizing: border-box;
            }
            
            #header {
                background-color: #000;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 0 0 calc(5px * var(--controls-scale));
                gap: calc(10px * var(--controls-scale));
            }
            
            #header button {
                cursor: pointer;
            }
            
            #header #jump-list {
                flex: 1 1 auto;
                display: flex;
                flex-wrap: wrap;
                list-style-type: none;
                margin: calc(5px * var(--controls-scale)) 0;
                padding: 0;
                gap: calc(2px * var(--controls-scale));
            }
            
            #header #jump-list li {
                display: block;
                padding: calc(2px * var(--controls-scale)) 0;
                margin: 0;
                flex: 0 0 auto;
            }
            
            #header #jump-list button {
                display: block;
                height: calc(8px * var(--controls-scale));
                width: calc(6px * var(--controls-scale));
                padding: 0;
                margin: 0;
                border: 1px solid #eee;
                border-radius: calc(2px * var(--controls-scale));
                background: rgba(255, 255, 255, 0.2);
            }
            
            #header #jump-list button:hover {
                border: 1px solid #fff;
                background: rgba(255, 255, 255, 0.4);
            }
            
            #header #jump-list button.current {
                border: 1px solid #fff;
                background: rgba(255, 255, 255, 0.4);
            }
            
            #header button#fullscreen {
                display: block;
                box-sizing: content-box;
                font-size: calc(1em * var(--controls-scale));
                line-height: calc(1em * var(--controls-scale));
                height: calc(1em * var(--controls-scale));
                margin: 0;
                padding: calc(5px * var(--controls-scale));
                color: #fff;
                background: transparent;
                border: none;
                aspect-ratio: 1;
            }
            
            #viewport {
                position: relative;
            }
            
            #viewport:hover button#prev,
            #viewport:hover button#next {
                opacity: 1;
            }
            
            #slider {
                background: black;
                display: flex;
                align-items: center;
                align-items: stretch;
                overflow-y: hidden;
                overflow-x: hidden;
                position: relative;
            }
            
            #slider figure {
                display: flex;
                padding: 0;
                margin: 0;
                width: 100%;
                flex: 1 0 auto;
                position: relative;
                align-items: center;
                justify-content: space-around;
            }
            
            #slider figure img,
            #slider figure picture {
                display: block;
                padding: 0;
                margin: 0;
                max-width: 100%;
            }
            
            #slider figcaption {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: rgba(0, 0, 0, 0.5);
                color: #fff;
                text-align: center;
                padding: 5px 10px;
                font-size: 0.75em;
                width: 100%;
                font-family: sans-serif;
                font-style: italic;
            }
            
            button#prev,
            button#next {
                user-select: none;
                font-size: 2.5em;
                cursor: pointer;
                border-radius: 100%;
                border: 3px solid rgba(0, 0, 0, 0.4);
                background-color: rgba(255, 255, 255, 0.4);
                color: transparent;
                display: block;
                box-sizing: content-box;
                width: 1em;
                height: 1em;
                line-height: 1em;
                position: absolute;
                margin: 0;
                padding: 0;
                top: calc(50% - 0.5em);
                opacity: 0;
                transition: opacity 0.1s ease-in;
            }
            
            button#prev:hover,
            button#next:hover {
                border-color: rgba(0, 0, 0, 0.5);
                background-color: rgba(255, 255, 255, 0.5);
            }
            
            button#prev::before,
            button#next::before {
                content: "";
                display: block;
                border: calc(1em / 4) solid transparent;
                position: absolute;
                top: calc(50% - (1em / 4));
            }
            
            button#prev {
                left: 10px;
            }
            button#prev::before {
                border-left-width: 0;
                border-right-color: rgba(0, 0, 0, 0.5);
                right: calc(50% - (1em / 10));
            }
            
            button#next {
                right: 10px;
            }
            button#next::before {
                border-right-width: 0;
                border-left-color: rgba(0, 0, 0, 0.5);
                left: calc(50% - (1em / 10));
            }
            
            #modal {
                position: fixed;
                top: 0px;
                left: 0px;
                right: 0px;
                bottom: 0px;
                z-index: var(--modal-z-index);
                padding: calc(10px + ((20px + 1em) * var(--controls-scale))) 20px;
                background-color: rgba(255, 255, 255, 0.8);
                display: flex;
                align-items: center;
                justify-content: space-around;
            }
            
            #modal button#close {
                position: absolute;
                top: 10px;
                right: 10px;
                font-weight: bold;
                padding: calc(10px * var(--controls-scale));
                background: transparent;
                border: none;
                cursor: pointer;
                display: block;
                font-size: calc(1em * var(--controls-scale));
                line-height: calc(1em * var(--controls-scale));
            }
            
            #modal #fullscreen-container {
                position: relative;
                display: flex;
                padding: 0;
                margin: 0;
                max-width: 100%;
                max-height: 100%;
            }
            
            #modal #fullscreen-container figure {
                padding: 0;
                margin: 0;
                max-width: 100%;
                max-height: 100%;
                flex: 0 0 auto;
            }
            
            #modal figure img,
            #modal figure picture {
                display: block;
                padding: 0;
                max-width: 100%;
                max-height: 100%;
                margin: 0 auto;
            }
            
            #modal figcaption {
                color: #000;
                font-family: sans-serif;
                text-align: center;
                font-style: italic;
                padding: 10px;
                background-color: #fff;
            }
            
            @media (hover: none) {
                :host {
                    --controls-scale: 1.25;
                }
                
                button#prev,
                button#next {
                    transition: none;
                    opacity: 1;
                }
            } 
        `;
        this.shadowRoot.appendChild(style);
        [...this.querySelectorAll("style")].forEach(c => this.shadowRoot.appendChild(c));

        const header = document.createElement("div");
        header.id = "header";

        const jumpList = document.createElement("menu");
        jumpList.id = "jump-list";
        header.appendChild(jumpList);

        const fullscreen = document.createElement("button");
        fullscreen.id = "fullscreen";
        fullscreen.innerHTML = "&#x26f6;";
        fullscreen.addEventListener(
            "click",
            function () {
                this.setAttribute(
                    "open",
                    ""
                );
            }.bind(this)
        );
        header.appendChild(fullscreen);

        this.shadowRoot.appendChild(header);

        const viewport = document.createElement("div");
        viewport.id = "viewport";

        const slider = document.createElement("div");
        slider.id = "slider";
        slider.replaceChildren(...this.images);
        slider.addEventListener("touchstart", function (e) {
            if (window.visualViewport?.width < this.shadowRoot.querySelector("#slider").clientWidth) {
                return;
            }

            const { changedTouches } = e;
            this.touchScaling = false;
            this.touchstartX = changedTouches[0].screenX;
        }.bind(this));
        slider.addEventListener("touchmove", function (e) {
            if (window.visualViewport?.width < this.shadowRoot.querySelector("#slider").clientWidth) {
                return;
            }

            const { touches, shiftKey } = e;

            if (touches.length === 1 && !shiftKey) {
                e.preventDefault();
            }
            else {
                this.touchScaling = true;
            }
        }.bind(this));
        slider.addEventListener("touchend", function ({ changedTouches }) {
            if (window.visualViewport?.width < this.shadowRoot.querySelector("#slider").clientWidth) {
                return;
            }

            if (this.touchScaling) {
                return;
            }

            this.touchendX = changedTouches[0].screenX;
            this.onSwipe();
        }.bind(this));
        viewport.appendChild(slider);

        const prev = document.createElement("button");
        prev.id = "prev";
        prev.innerHTML = "&laquo;";
        prev.addEventListener("click", this.decrementPos);
        viewport.appendChild(prev);

        const next = document.createElement("button");
        next.id = "next";
        next.innerHTML = "&raquo;";
        next.addEventListener("click", this.incrementPos);
        viewport.appendChild(next);

        this.shadowRoot.appendChild(viewport);

        this.data = JSON.parse(this.querySelector("script[type='application/json']").textContent);

        this.images = this.data.map(function ({ src, title, alt, caption }, i) {
            const figure = document.createElement("figure");
            figure.addEventListener("dblclick", function () {
                this.setAttribute("pos", i+1);
                this.setAttribute("open", "");
            }.bind(this));

            const img = document.createElement("img");
            img.src = src;
            img.alt = alt || title;
            img.title = title;
            figure.appendChild(img);

            if (caption) {
                const figcaption = document.createElement("figcaption");
                figcaption.innerHTML = caption;
                figure.appendChild(figcaption);
            }

            return figure;
        }.bind(this));

        jumpList.replaceChildren(...this.images.map(function (_, i) {
            const item = document.createElement("li");

            const button = document.createElement("button");
            button.setAttribute("aria-label", `#${i + 1}`);
            button.addEventListener(
                "click",
                function () {
                    this.setAttribute("pos", i + 1);
                }.bind(this)
            );

            item.appendChild(button);
            return item;
        }.bind(this)));
        slider.replaceChildren(...this.images);

        if (this.getAttribute("pos") === null) {
            this.setAttribute("pos", "1");
        }

        this.render();
    }

    render() {
        const idx = ((parseInt(this.getAttribute("pos"), 10) - 1) + this.images.length) % this.images.length;
        const slider = this.shadowRoot.querySelector("#slider");
        slider.scrollTo({ left: this.images[idx].offsetLeft, behavior: "smooth" });
        const jumpList = this.shadowRoot.querySelectorAll("#jump-list button");
        jumpList.forEach((e) => e.classList.remove("current"));
        jumpList[idx]?.classList.add("current");

        this.shadowRoot.querySelector("#modal")?.remove();

        if (this.getAttribute("open") !== null) {
            const modal = document.createElement("div");
            modal.id = "modal";
            modal.addEventListener("click", function ({ target }) {
                if (target.id === "modal") {
                    this.removeAttribute("open");
                }
            }.bind(this));
            window.addEventListener("keyup", function ({ key }) {
                if (key === "Escape") {
                    this.removeAttribute("open");
                }
            }.bind(this));

            const fullscreenContainer = document.createElement("div");
            fullscreenContainer.id = "fullscreen-container";
            fullscreenContainer.innerHTML = this.images[idx].outerHTML;
            modal.appendChild(fullscreenContainer);

            const close = document.createElement("button");
            close.id = "close";
            close.innerHTML = "&#x2573;";
            close.addEventListener(
                "click",
                function () {
                    this.removeAttribute("open");
                }.bind(this)
            );
            modal.appendChild(close);

            this.shadowRoot.appendChild(modal);
        }
    }

    decrementPos() {
        let newPos = parseInt(this.getAttribute("pos"), 10) - 1;

        if (this.getAttribute("wraparound") === null) {
            newPos = Math.max(newPos, 1);
        } else {
            newPos = newPos <= 0 ? (this.images.length - newPos) : newPos;
        }

        this.setAttribute(
            "pos",
            newPos.toString()
        );
    }

    incrementPos() {
        let newPos = parseInt(this.getAttribute("pos"), 10) + 1;

        if (this.getAttribute("wraparound") === null) {
            newPos = Math.min(newPos, this.images.length);
        } else {
            newPos = newPos > this.images.length ? (newPos % this.images.length) : newPos;
        }

        this.setAttribute(
            "pos",
            newPos.toString()
        );
    }

    onSwipe() {
        if (this.touchendX < this.touchstartX) {
            this.incrementPos();
        }
        if (this.touchendX > this.touchstartX) {
            this.decrementPos();
        }
    }

    attributeChangedCallback(name) {
        switch (name) {
            case "pos":
            case "open":
            case "wraparound":
                this.render();
                return;
        }
    }

    static get observedAttributes() {
        return ["pos", "open", "wraparound"];
    }
}

export default ImageSlider;
